import React from "react";
import { toggleFollow, useFollowing } from "./follow";
import "./follow.css";

// The follow icon on paper cards (and the Follow button on a paper's page with `big`).
// Shows the reader's state; tapping again unfollows. Signed-out readers go to sign in.
export default function FollowButton({ id, name, signedIn, onSignIn, big, light }) {
  const ids = useFollowing();
  const on = signedIn && ids.has(String(id));
  const click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!signedIn) { if (onSignIn) onSignIn(); return; }
    toggleFollow(id, name);
  };
  const label = on ? `Following ${name || "this paper"}. Tap to unfollow` : `Follow ${name || "this paper"}`;
  if (big) {
    return (
      <button type="button" className={`pp-btn pp-btn-outline fl-big ${on ? "on" : ""}`} aria-pressed={on} aria-label={label} onClick={click}>
        {on ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
        )}
        {on ? "Following" : "Follow"}
      </button>
    );
  }
  return (
    <button type="button" className={`fl-icon${light ? " fl-light" : ""} ${on ? "on" : ""}`} aria-pressed={on} aria-label={label} title={on ? "Following · tap to unfollow" : "Follow"} onClick={click}>
      <i className={on ? "fas fa-user-check" : "fas fa-user-plus"} aria-hidden="true" />
    </button>
  );
}
